import type { NewsArticle } from "@/types";

export const newsList: NewsArticle[] = [
  {
    id: "news-01",
    title: "2024年度华语电影观察：类型融合成为主流，中小成本佳作频出",
    summary:
      "从科幻悬疑到古装奇幻，今年的华语电影在类型融合上走得更远。多部中小成本作品凭借扎实剧本与新鲜表达赢得口碑，为市场注入新的活力。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20empty%20modern%20movie%20theater%20auditorium%20with%20warm%20ambient%20lighting%20and%20rows%20of%20red%20seats%2C%20soft%20spotlight%20on%20the%20blank%20screen%2C%20editorial%20film%20industry%20photography%2C%20moody%20refined%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-01&orientation=landscape",
    author: "影评人 · 沈未",
    date: "2024-10-08",
    tags: ["行业观察", "华语电影"],
    content: [
      "过去一年，华语电影市场最显著的变化，是类型边界的不断模糊。科幻与悬疑、古装与奇幻、爱情与都市喜剧的组合，成为创作者们乐于尝试的方向。观众对单一类型的审美疲劳，反而推动了叙事方式的更新。",
      "值得注意的是，多部在本站榜单中热度居高不下的作品，并非出自大制作，而是依靠扎实的剧本和鲜明的作者风格脱颖而出。这在一定程度上说明，观众正在用脚投票，为好故事而非大场面买单。",
      "从数据上看，本站「热门电影」前二十中，中小成本影片占据了近一半席位。它们往往在某一类型上做深做透，再以细腻的人物刻画打动人，这种「小而精」的路线，正在成为新的性价比之选。",
      "当然，类型融合也带来风险：元素堆砌而缺乏内核的作品同样不少。如何在新的组合中保持情感的真实，仍是每一位创作者需要回答的问题。",
    ],
  },
  {
    id: "news-02",
    title: "电视剧「追更时代」：周更、长剧与短剧的三重博弈",
    summary:
      "周更模式重塑了观众的追剧习惯，长剧集与短剧集在同一平台上展开竞争。内容节奏与观众耐心之间，正在形成新的平衡。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20scene%20with%20a%20glowing%20TV%20screen%20and%20popcorn%20on%20a%20coffee%20table%20at%20dusk%2C%20soft%20warm%20ambient%20light%2C%20relaxed%20streaming%20night%20mood%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=500&seq=news-02&orientation=landscape",
    author: "内容编辑 · 温禾",
    date: "2024-09-26",
    tags: ["电视剧", "行业观察"],
    content: [
      "「追更」已经取代「刷完」，成为越来越多剧迷的日常。周更模式一方面拉长了作品的讨论周期，让话题持续发酵；另一方面，也对剧集前几集的节奏提出了更高要求。",
      "与此同时，短剧集凭借紧凑的叙事和明确的情绪钩子快速崛起。长剧集则转向更细腻的群像刻画，试图用厚度留住观众。两者的受众虽有重叠，但观看场景和期待值差异明显。",
      "对普通观众而言，这其实是好消息：无论你是想用几个晚上一口气看完，还是想用一整个季度陪伴一个故事，都能找到合适的选择。",
    ],
  },
  {
    id: "news-03",
    title: "高清修复浪潮：经典老片为何重返观众视野",
    summary:
      "一批经典影视作品经过高清修复重新上线，画质提升的同时，也唤起了跨代际的观影共鸣。修复技术进步，让老故事获得新的生命。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20and%20a%20moviola%20editing%20machine%20on%20a%20wooden%20table%20in%20a%20warm%20archive%20room%2C%20scattered%20film%20strips%2C%20nostalgic%20golden%20light%2C%20retro%20editorial%20photography%2C%20softly%20blurred%20background%2C%20high%20detail&width=800&height=500&seq=news-03&orientation=landscape",
    author: "技术编辑 · 顾言",
    date: "2024-09-12",
    tags: ["修复", "经典影视"],
    content: [
      "高清修复并非简单地把画面放大。色彩还原、噪点抑制、音轨重建，每一项都需要大量人工介入。一部两小时的老片，完整修复周期往往以月计。",
      "修复带来的不只是清晰度。当尘封的胶片被重新点亮，那些曾经只能在模糊录像里重温的场景，第一次以接近创作者本意的方式呈现，感动也随之被重新放大。",
      "在本站，多部修复重映的经典作品都进入了「年代精选」榜单。年轻观众第一次在大屏上完整看完父辈的青春，而老观众则找回了记忆里的那束光。",
    ],
  },
  {
    id: "news-04",
    title: "悬疑题材持续走热：观众到底在期待什么",
    summary:
      "从本格推理到社会派悬疑，悬疑题材始终占据着热度榜前列。强叙事与人物深度，是这类作品留住观众的两大关键。",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20dark%20desk%20covered%20with%20vintage%20photographs%2C%20red%20string%20connections%20and%20a%20magnifying%20glass%20under%20a%20single%20lamp%2C%20moody%20detective%20investigation%20mood%2C%20film%20noir%20palette%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=news-04&orientation=landscape",
    author: "影评人 · 沈未",
    date: "2024-08-30",
    tags: ["悬疑", "观剧指南"],
    content: [
      "悬疑之所以长盛不衰，是因为它天然契合了「想知道接下来发生什么」这一最朴素的观看动机。但真正被记住的作品，靠的绝不只是反转。",
      "近年来口碑突出的悬疑剧，往往在解谜之外，对人性与现实的描摹同样扎实。观众在跟随主角破案的同时，也在重新审视自己身处的世界。",
      "选题指南：如果你偏爱逻辑缜密的本格推理，可以从本站「悬疑」标签下评分最高的作品入手；如果你更看重人物与情感，社会派作品会更对你的胃口。",
    ],
  },
  {
    id: "news-05",
    title: "十月观影片单：本周值得关注的六部新上线作品",
    summary:
      "本周平台上线多部重量级新片与新剧，涵盖科幻、动作、都市与历史题材。这份片单帮你在有限时间里选出最值得看的那一部。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20a%20film%20slate%2C%20clapperboard%2C%20popcorn%20and%20a%20notebook%20on%20a%20light%20surface%2C%20fresh%20editorial%20content%20curation%20mood%2C%20clean%20bright%20tones%20with%20warm%20accent%2C%20top-down%20photography%2C%20high%20detail&width=800&height=500&seq=news-05&orientation=landscape",
    author: "内容编辑 · 温禾",
    date: "2024-10-11",
    tags: ["片单", "新上线"],
    content: [
      "本周上线作品数量不少，题材分布也相当均衡。科幻迷推荐关注《星海归途》，它在硬核设定的外壳下，讲的其实是一个关于「回家」的温柔故事。",
      "喜欢动作与港片质感的观众，《无间风暴》不会让你失望；而想要轻松一点的周末夜晚，《一笑倾城》这样的都市喜剧是很好的下饭菜。",
      "剧集方面，《烽火长歌》与《暗夜行者》分别在历史与谍战赛道交出了高分答卷。前者胜在格局，后者胜在氛围。",
      "最后提醒一句：以上作品均可在本站详情页查看简介与相关推荐，播放入口为演示功能，实际观看请前往正规平台。",
    ],
  },
  {
    id: "news-06",
    title: "从「看什么」到「怎么看」：观众选择成本的下降",
    summary:
      "分类筛选、评分排序与智能推荐，正在帮助观众更快找到想看的内容。降低选择成本，或许是内容平台最重要的体验命题。",
    cover:
      "https://readdy.ai/api/search-image?query=Person%20relaxing%20on%20a%20sofa%20browsing%20a%20streaming%20catalog%20grid%20on%20a%20tablet%2C%20warm%20inviting%20living-room%20light%2C%20comfortable%20evening%20mood%2C%20editorial%20lifestyle%20photography%2C%20soft%20blur%2C%20high%20detail&width=800&height=500&seq=news-06&orientation=landscape",
    author: "产品观察 · 林川",
    date: "2024-08-16",
    tags: ["用户体验", "产品"],
    content: [
      "内容爆炸的时代，真正的稀缺不是内容，而是注意力。对观众来说，最大的痛点早已不是「没得看」，而是「不知道看什么」。",
      "因此，一个清晰的分类结构、可信的评分体系、以及多条件组合的筛选，其价值往往被低估。它们直接决定了用户能否在三十秒内找到想看的作品。",
      "本站的分类页提供了地区、年份、类型与排序的组合筛选，目的正是把「翻找」的成本降到最低，让挑选本身也成为一种轻松愉快的体验。",
    ],
  },
  {
    id: "news-07",
    title: "古装剧的「新古典主义」：服化道之外的故事内核",
    summary:
      "精致的服化道已成古装剧标配，而真正拉开差距的，是故事是否能在古典外壳下回应当代观众的情感与困惑。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20costumes%20and%20silk%20fabrics%20displayed%20on%20mannequins%20in%20a%20softly%20lit%20atelier%2C%20intricate%20embroidery%20detail%2C%20jade%20and%20gold%20tones%2C%20refined%20period-drama%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=news-07&orientation=landscape",
    author: "文化编辑 · 闻莺",
    date: "2024-07-29",
    tags: ["古装剧", "文化"],
    content: [
      "当服化道从卖点变成底线，古装剧的竞争就自然而然地回到了故事本身。观众越来越不满足于「好看」，而是期待「好看且有想法」。",
      "所谓「新古典主义」，是把古典的审美与当代的价值观相嫁接：既保留传统的意蕴，又让人物在权利、情感与自我实现上的挣扎，能引起今天的共鸣。",
      "近期表现亮眼的《锦绣山河》《青云志远》，恰好是这一路径的两个样本：前者写权谋中的人心，后者写江湖里的成长。",
    ],
  },
  {
    id: "news-08",
    title: "家庭观影回归客厅：大屏与共看场景的重新流行",
    summary:
      "智能大屏的普及，让「一家人一起看」重新回到日常。适合共看的合家欢与温情题材，也因此获得更多关注。",
    cover:
      "https://readdy.ai/api/search-image?query=Family%20silhouettes%20watching%20a%20bright%20living-room%20TV%20together%20in%20the%20evening%2C%20warm%20glow%20from%20the%20screen%2C%20cozy%20togetherness%20mood%2C%20soft%20amber%20and%20teal%20palette%2C%20editorial%20lifestyle%20photography%2C%20high%20detail&width=800&height=500&seq=news-08&orientation=landscape",
    author: "生活编辑 · 何嘉",
    date: "2024-07-10",
    tags: ["家庭观影", "生活方式"],
    content: [
      "「一人一屏」的时代，客厅里的那块大屏反而成了稀缺的公共空间。当一家人重新坐在一起看同一部作品，观影就从个人消遣变回了家庭活动。",
      "这也解释了合家欢、温情剧情与经典修复影片近来的热度上升。它们节奏不急、情感普适，适合不同年龄的家人一起进入。",
      "选片建议：把评分与题材都纳入考量，优先选择时长适中、情绪正向的作品，让「一起看」成为一件轻松愉快的事。",
    ],
  },
  {
    id: "news-09",
    title: "短剧之后，长视频如何讲好一个「慢故事」",
    summary:
      "在注意力被不断切碎的环境里，仍然有一批观众愿意为「慢」买单。耐心叙事如何在快节奏时代找到自己的位置？",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20minimalist%20reading%20nook%20with%20an%20armchair%2C%20warm%20lamp%20and%20stacks%20of%20film%20books%20by%20a%20window%20in%20soft%20daylight%2C%20contemplative%20slow-living%20mood%2C%20calm%20neutral%20palette%20with%20warm%20accent%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=news-09&orientation=landscape",
    author: "专题作者 · 陆遥",
    date: "2024-06-21",
    tags: ["专题", "叙事"],
    content: [
      "短剧用效率取胜，长视频则用沉浸感取胜。当观众主动选择一部慢节奏作品时，他们购买的其实是一段不被切碎的时间。",
      "讲好慢故事的关键，不在于慢本身，而在于慢得有价值：每一个停顿都应承载信息或情绪，让观众感到「值得等待」。",
      "对创作者而言，这意味着更克制的表达和更笃定的主题。对观众而言，这意味着一份可贵的耐心——而这份耐心，恰恰是好作品值得被给予的礼物。",
    ],
  },
];